module.exports = __webpack_public_path__ + "static/media/border-style.d8f2fadd.svg";